"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
const Card = (_a) => {
    var { heading, children } = _a, rest = __rest(_a, ["heading", "children"]);
    return (jsx_runtime_1.jsxs(react_1.Box, Object.assign({ rounded: "lg", overflow: "hidden", borderWidth: "1px", bg: "white" }, rest, { children: [heading ? (jsx_runtime_1.jsx(react_1.Box, Object.assign({ px: "4", py: "5", borderBottom: "1px", borderColor: "gray.200", fontSize: "lg", color: "gray.900", fontWeight: "medium", lineHeight: "leading-6" }, { children: heading }), void 0)) : null, children] }), void 0));
};
exports.Card = Card;
